import React from "react";
import { Card } from "antd";

const Earnings = () => {
    return (
        <Card title="Mes gains">
            <h2>120 000 FCFA</h2>
            <p>+20% ce mois</p>
        </Card>
    );
};

export default Earnings;